import styled from 'styled-components';
import { shimmerAnimation } from 'styles/animations';

export const ContactDrawerFirstStepWrapper = styled.div`
  max-height: 100%;

  display: flex;
  flex-direction: column;
`;

export const ContactDrawerFirstStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 26px 32px 106px 32px;

  overflow-y: auto;
`;

export const ContactDrawerFirstStepCopyIcon = styled.div`
  cursor: pointer;

  position: relative;
`;

export const ContactDrawerFirstStepCopyPopover = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;

  padding: 8px 16px;

  border-radius: 8px;
  background: #000000;

  transform: translate(-25%, 25%);

  z-index: 99999999;
`;

export const ContactDrawerFirstStepCopyPopoverLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
`;

export const ContactDrawerFirstStepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ContactDrawerFirstStepListTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContactDrawerFirstStepListTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ContactDrawerFirstStepListTitleCheckbox = styled.input``;

export const ContactDrawerFirstStepListTitle = styled.h4`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);
`;

//LIST ITEM SKELETON
export const ContactDrawerFirstStepListItemSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 8px;
`;

export const ContactDrawerFirstStepListItemLeftContainerSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ContactDrawerFirstStepListItemCheckboxSkeleton = styled.div`
  ${shimmerAnimation()}

  width: 13px;
  height: 13px;

  background: linear-gradient(
    to right,
    rgba(173, 173, 173, 0.3) 4%,
    rgba(173, 173, 173, 0.5) 25%,
    rgba(173, 173, 173, 0.3) 36%
  );
  background-size: 500px 100%;
`;

export const ContactDrawerFirstStepListItemAvatarSkeleton = styled.div`
  ${shimmerAnimation()}

  width: 40px;
  height: 40px;

  border-radius: 100%;
  background: linear-gradient(
    to right,
    rgba(173, 173, 173, 0.3) 4%,
    rgba(173, 173, 173, 0.5) 25%,
    rgba(173, 173, 173, 0.3) 36%
  );
  background-size: 500px 100%;
`;

export const ContactDrawerFirstStepListItemInformationContainerSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ContactDrawerFirstStepListItemNameSkeleton = styled.div`
  ${shimmerAnimation()}

  width: 77px;
  height: 18px;

  background: linear-gradient(
    to right,
    rgba(173, 173, 173, 0.3) 4%,
    rgba(173, 173, 173, 0.5) 25%,
    rgba(173, 173, 173, 0.3) 36%
  );
  background-size: 500px 100%;
  border-radius: 4px;
`;

export const ContactDrawerFirstStepListItemInformationSkeleton = styled.div`
  ${shimmerAnimation()}

  width: 274px;
  height: 20px;

  background: linear-gradient(
    to right,
    rgba(173, 173, 173, 0.3) 4%,
    rgba(173, 173, 173, 0.5) 25%,
    rgba(173, 173, 173, 0.3) 36%
  );
  background: rgba(173, 173, 173, 0.3);
  background-size: 500px 100%;
  border-radius: 4px;
`;

export const ContactDrawerFirstStepListItemCounterSkeleton = styled.div`
  ${shimmerAnimation()}

  width: 48px;
  height: 26px;

  background: linear-gradient(
    to right,
    rgba(173, 173, 173, 0.3) 4%,
    rgba(173, 173, 173, 0.5) 25%,
    rgba(173, 173, 173, 0.3) 36%
  );
  background-size: 500px 100%;
  border-radius: 4px;
`;

export const ContactDrawerFirstStepListItemCopySkeleton = styled.div`
  ${shimmerAnimation()}

  width: 24px;
  height: 24px;

  background: linear-gradient(
    to right,
    rgba(173, 173, 173, 0.3) 4%,
    rgba(173, 173, 173, 0.5) 25%,
    rgba(173, 173, 173, 0.3) 36%
  );
  background-size: 500px 100%;
  border-radius: 4px;
`;

//LIST ITEMS
export const ContactDrawerFirstStepListItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 8px;
`;

export const ContactDrawerFirstStepListItemLeftContainer = styled.div`
  flex: 1;
  max-width: 322px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ContactDrawerFirstStepListItemPersonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;

  cursor: pointer;
`;

export const ContactDrawerFirstStepListItemRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const ContactDrawerFirstStepListItemCheckboxContainer = styled.div`
  width: 15px;
  height: 15px;

  position: relative;
`;

export const ContactDrawerFirstStepListItemCheckbox = styled.input`
  width: 15px;
  height: 15px;

  position: absolute;
  top: 0px;
  left: 0px;

  &:checked + div {
    display: flex;
  }

  &:checked {
    opacity: 0;
  }

  cursor: pointer;
`;

export const ContactDrawerFirstStepListItemCheckboxBackground = styled.div`
  display: none;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0px;
  left: 0px;

  height: 15px;
  width: 15px;
  border-radius: 2px;

  background: var(--color-data-people-foreground);

  pointer-events: none;
`;

export const ContactDrawerFirstStepListItemInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ContactDrawerFirstStepListItemName = styled.h4`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const ContactDrawerFirstStepListItemInformation = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: var(--color-text);
`;

export const ContactDrawerFirstStepListItemInformationCompanyName = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: var(--color-data-company-foreground);
`;

//CTA
export const ContactDrawerFirstStepCTAContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;

    background: rgba(23, 28, 51, 0.02);
    backdrop-filter: blur(50px);
  }

  position: relative;
`;

export const ContactDrawerFirstStepCTAButton = styled.button`
  flex: 1;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 16px 32px 16px 48px;

  border-radius: 100px;
  background: ${({ theme }) =>
    !theme.enabled ? 'var(--color-data-alumni-background)' : 'var(--color-primary)'};

  z-index: 1;
`;

export const ContactDrawerFirstStepCTAButtonLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: ${({ theme }) => (!theme.enabled ? 'var(--color-text)' : '#ffffff')};
`;

//CONTEXT
export const ContactDrawerFirstStepContextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
